<template>
    <div class="adminUserList">
        <Breadcumb :title="$t('surveys_list')" :breadcumb-data="breadcumbData">
        </Breadcumb>
        <b-card no-body class="mb-3 cardcontainer">
            <b-card-body>
                <b-form inline class="" @submit="searchSurvey">
                    <datepicker style="min-width:250px" class="mr-sm-2  mb-sm-0" v-model="date_begin" :bootstrapStyling="true" :placeholder="$t('survey_begin_date')"/>
                    <datepicker style="min-width:250px" class="mr-sm-2  mb-sm-0" v-model="date_end" :bootstrapStyling="true" :placeholder="$t('survey_end_date')"/>
                    <b-select class="custom-select mr-sm-2  mb-sm-0" v-model="type" value="Type d'enquête" :options=typeData />
                    <b-select class="custom-select mr-sm-2  mb-sm-0" v-model="state" value="Etats" :options=stateData />
                    <b-select class="custom-select mr-sm-2  mb-sm-0" v-model="provider" value="Prestataire" :options=providerData />
                    <b-btn type="submit" variant="primary">{{ $t('search')}}</b-btn>
                    <b-btn @click="resetResearch()" variant="default"><i class="ion ion-md-close"></i></b-btn>
                </b-form>
            </b-card-body>
        </b-card>
        <b-card no-body>
            <!-- Table controls -->
           
            <b-card-body>
                <b-btn class="mt-3 mb-3" variant="success" @click="downloadPerimeterStructure()">Télécharger la structure organisationnelle</b-btn>
                <b-btn class="mt-3 mb-3" variant="success" @click="downloadReporting()">Télécharger le rapport</b-btn>
                <b-table
                        :items="surveysData"
                        :fields="fields"
                        :striped="true"
                        :bordered="true"
                        class="card-table">
                    <template slot="ID" slot-scope="data">
                        {{data.item.id}}
                    </template>
                    <template  :slot="$t('label')" slot-scope="data">
                        {{data.item.label}}
                    </template>
                    <template :slot="$t('survey_type')" slot-scope="data">
                        <b-badge variant="outline-default" v-if="data.item.type === 'grouplocal'" v-html="$t('group_survey_specificities')"></b-badge>
                        <b-badge variant="outline-default" v-if="data.item.type === 'group'" v-html="$t('group_baro')"></b-badge>
                    </template>
                    <template :slot="$t('publication_date')" slot-scope="data">
                        {{ data.item.publication_date|formatDateNoH }} -  {{ data.item.publication_end|formatDateNoH }}
                    </template>
                    <template :slot="$t('company')" slot-scope="data">
                        <b-btn v-on:click="companies=data.item.companies; $refs.companiesmodal.open()" variant="default btn-xs md-btn-flat">
                            <i class="ion ion-md-git-network"></i>
                        </b-btn>
                    </template>
                    <template :slot="$t('language')" slot-scope="data">
                        <b-btn v-on:click="languages=data.item.language; $refs.languagemodal.open()" variant="default btn-xs md-btn-flat">
                            <i class="ion ion-md-git-network"></i>
                        </b-btn>
                    </template>
                    <template :slot="$t('collaborator_file')" slot-scope="data">
                        <b-btn v-on:click="downloadTemplate(data.item.id)" variant="default btn-xs md-btn-flat">
                            Template
                        </b-btn>
                        <span v-if="data.item.partner_type === 'directobea'">
                            <b-badge variant="outline-danger" v-if="data.item.target_date === null">{{ $t('missing_file') }}</b-badge>
                        <b-badge variant="outline-success" v-if="data.item.target_date">{{ $t('sended')}} {{ data.item.target_date|formatDateNoH }}</b-badge>
                        <b-btn v-if="data.item.target_date" v-on:click="downloadTargets(data.item.id)" variant="default btn-xs md-btn-flat">
                          <i class="ion ion-md-cloud-download"></i>
                        </b-btn>
                        <b-btn v-on:click="survey_id=data.item.id; $refs.formodal.open()" variant="default btn-xs md-btn-flat">
                          <i class="ion ion-md-add-circle"></i>
                        </b-btn>
                        </span>
                                    <span v-else>
                            <b-btn v-on:click="$refs.notobea.open()" variant="default btn-xs md-btn-flat">
                          <i class="ion ion-md-more"></i>
                        </b-btn>
                        </span>
                    </template>
                    <template :slot="$t('provider')" slot-scope="data">
                        <span v-if="data.item.partner_type === 'otherpartner'">{{ $t('external')}}</span>
                        <span v-if="data.item.partner_type === 'otherpartner'">
                            <b-badge variant="outline-danger" v-if="data.item.rawresults_date === null">{{ $t('unsubmitted_result')}}</b-badge>
                            <b-badge variant="outline-success" v-if="data.item.rawresults_date">{{ $t('submitted_the')}} {{ data.item.rawresults_date|formatDateNoH }}</b-badge>
                        </span>
                        <span v-if="data.item.partner_type === 'otherpartner' && user.userprofile.user_type.position === 0">
                            <b-btn v-if="data.item.target_date" v-on:click="downloadTargets(data.item.id)" variant="default btn-xs md-btn-flat">
                                <i class="ion ion-md-cloud-download"></i>
                            </b-btn>
                            <b-btn v-on:click="survey_id=data.item.id; $refs.formodal.open()" variant="default btn-xs md-btn-flat">
                                <i class="ion ion-md-add-circle"></i>
                            </b-btn>
                            <b-btn v-if="data.item.rawresults_date" v-on:click="downloadRawResults(data.item.id)" variant="default btn-xs md-btn-flat">
                            <i class="ion ion-md-cloud-download"></i>
                            </b-btn>
                        </span>
                        
                        <span v-if="data.item.partner_type !== 'otherpartner'">OBEA</span>
                    </template>
                    <template :slot="$t('state')" slot-scope="data">
                        <b-badge variant="outline-success" v-if="data.item.state === 'COM'">{{ $t('created')}}</b-badge>
                        <b-badge variant="outline-warning" v-if="data.item.state === 'INC'">{{ $t('draft')}}</b-badge>
                    </template>
                    <template :slot="$t('question')" slot-scope="data">
                        <b-btn v-on:click="onexport(data.item.id)" variant="default btn-xs md-btn-flat">
                            {{ $t('download_question')}}
                        </b-btn>
                    </template>
                </b-table>
            </b-card-body>
            <sweet-modal width="80%" ref="formodal" height="80%">
                <form @submit="addTargetFile">
                    <b-form-group label="Fichier collaborateurs" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                        <b-file v-model="document" ref="document"/>
                    </b-form-group>
                    <b-btn type="submit" variant="primary" slot="finish">Ajouter</b-btn>
                </form>
            </sweet-modal>
            <sweet-modal width="80%" ref="companiesmodal" height="80%">
                <b-badge variant="outline-default" v-for="company in companies">{{ company.name }}</b-badge>
            </sweet-modal>
            <sweet-modal width="80%" ref="languagemodal" height="80%">
                <template v-if="$cookie.get('language') == 'en'">
                    <b-badge variant="outline-default" v-for="language in languages">{{ language.name_en }}</b-badge>
                </template>
                <template v-if="$cookie.get('language') == 'fr'">
                    <b-badge variant="outline-default" v-for="language in languages">{{ language.name }}</b-badge>
                </template>
            </sweet-modal>
            <sweet-modal width="80%" ref="notobea" height="80%">
                <span v-html="$t('collab_file_disclaimer')"></span>
            </sweet-modal>
        </b-card>
    </div>
</template>
<style src="@/vendor/libs/sweet-modal-vue/sweet-modal-vue.scss" lang="scss"></style>
<style src="@/vendor/libs/vuejs-datepicker/vuejs-datepicker.scss" lang="scss"></style>
<script>
    import {
        GET_REPORTING_REQUEST,
        GET_SURVEY_REQUEST,
        GET_SURVEYS_REQUEST,
        PROVIDER_CUSTOM_TEMPLATE_REQUEST, RRH_CUSTOM_TEMPLATE_REQUEST,
        SURVEY_ADD_TARGETS_REQUEST
    } from '../../_store/survey/actiontypes'
    import Breadcumb from '../../components/breadcumb'
    import Datepicker from 'vuejs-datepicker'
    import moment from 'moment'
    import XLSX from 'xlsx';
    import slugify from 'slugify'
    import {SweetModal, SweetModalTab} from 'sweet-modal-vue'
    import { mapState } from 'vuex'
    import {GET_PERIMETER_STRUCTURE_REQUEST} from "../../_store/company/actiontypes";

    function pdfBlobConvesion(b64Data, contentType) {
        contentType = contentType || '';
        var sliceSize = 512;
        b64Data = b64Data.replace(/^[^,]+,/, '');
        b64Data = b64Data.replace(/\s/g, '');
        var byteCharacters = window.atob(b64Data);
        var byteArrays = [];

        for ( var offset = 0; offset < byteCharacters.length; offset = offset + sliceSize ) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
    function getBase64(file) {
        return new Promise((resolve, reject) => {
            if (file === undefined) {
                return resolve(null);
            } else {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            }
        });
    }
    
    export default {
        name: 'adminUserList',
        mounted() {
            this.stateData = [
            {
                value: '',
                text: this.$t('state') + '...'
            },
            {
                value: 'INC',
                text: this.$t('draft')
            },
            {
                value: 'COM',
                text: this.$t('created')
            }];
            this.typeData = [
                {
                    value: '',
                    text: this.$t('survey_type'),
                },
                {
                    value: 'group',
                    text: this.$t('group_baro'),
                },
                {
                    value: 'grouplocal',
                    text:  this.$t('group_survey_specificities'),
                }
            ];
            this.fields = [
                {
                key: 'ID',
                sortable: false,
                tdClass: 'align-middle'
            },
                {
                    key: this.$t('label'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
                {
                    key: this.$t('survey_type'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
                {
                    key: this.$t('publication_date'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
                {
                    key: this.$t('language'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
                {
                    key: this.$t('company'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
                {
                    key: this.$t('state'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
                {
                    key: this.$t('collaborator_file'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
                {
                    key: this.$t('provider'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
                {
                    key: this.$t('question'),
                    sortable: false,
                    tdClass: 'align-middle'
                }
            ]
            this.breadcumbData = [
                { text: this.$t('welcome'), href: '/dashboard/' },
                { text: this.$t('surveys_list'), active: true },
            ],
            this.$store.dispatch(GET_SURVEYS_REQUEST)
                .then(response => {
                    this.surveysData = response.data.surveys
                })
        },
        computed: mapState({
            user: state => state.user.user
        }),
        components: { Breadcumb, Datepicker, SweetModalTab, SweetModal},
        data() {
            return {
                breadcumbData: [],
                dataUrl: 'json/pages_users_list.json',
                date_end: '',
                date_begin: '',
                state: '',
                document: false,
                survey_id: false,
                type: '',
                provider:'',
                stateData: [],
                providerData: [
                    {
                        value: 'directobea',
                        text: 'OBEA'
                    },
                    {
                        value: 'otherpartner',
                        text: 'Préstataire autre qu\'Obea'
                    }
                ],
                typeData: [],
                fields: [],
                surveysData: [],
                currentPage: 1,
                companies: [],
                languages: []
            };
        },
        layout(context) {
            return 'layout';
        },
        methods: {
            downloadPerimeterStructure() {
                this.$store.dispatch(GET_PERIMETER_STRUCTURE_REQUEST)
                    .then(response => {
                        let file = response.data.encoded_string.file;
                        let type = file.split(';')[0].split('/')[1];
                        let original_type = type;
                        if (type === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
                            type = "xlsx";
                        }
                        const linkSource = file;
                        const downloadLink = document.createElement("a");
                        const fileName = "perimeterstructure.xlsx";
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(pdfBlobConvesion(linkSource, original_type), fileName);
                        }
                        else {
                            downloadLink.click();
                            document.body.appendChild(downloadLink);
                        }
                    })
                    .catch(error => {
                        console.log("ERROR is ====");
                        console.log(error)
                    })
            },
            downloadReporting() {
                this.$store.dispatch(GET_REPORTING_REQUEST)
                    .then(response => {
                        let file = response.data.encoded_string.file;
                        let type = file.split(';')[0].split('/')[1];
                        let original_type = type;
                        if (type === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
                            type = "xlsx";
                        }
                        const linkSource = file;
                        const downloadLink = document.createElement("a");
                        const fileName = "reporting.xlsx";
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(pdfBlobConvesion(linkSource, original_type), fileName);
                        }
                        else {
                            downloadLink.click();
                            document.body.appendChild(downloadLink);
                        }
                    })
                    .catch(error => {
                        console.log("ERROR is ====");
                        console.log(error)
                    })
            },
            downloadTemplate(survey_id) {
                this.$store.dispatch(RRH_CUSTOM_TEMPLATE_REQUEST, survey_id)
                    .then(response => {
                        console.log(response.data);
                        let file = response.data.encoded_string.file;
                        let type = file.split(';')[0].split('/')[1];
                        let original_type = type;
                        if (type === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
                            type = "xlsx";
                        }
                        const linkSource = file;
                        const downloadLink = document.createElement("a");
                        const fileName = survey_id + "_template_enquete.xlsx";
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(pdfBlobConvesion(linkSource, original_type), fileName);
                        }
                        else {
                            downloadLink.click();
                            document.body.appendChild(downloadLink);
                        }
                    })
                    .catch(error => {
                        console.log("ERROR is ====");
                        console.log(error)
                    })
            },
            resetResearch(){
                this.type = '';
                this.date_end =  '';
                this.date_begin = '';
                this.state = '';
                this.provider = '';
                this.$store.dispatch(GET_SURVEYS_REQUEST)
                    .then(response => {
                        this.surveysData = response.data.surveys
                    })
            },
            addTargetFile: function (e) {
                e.preventDefault();
                console.log(this.survey_id);
                getBase64(this.$refs.document.$el.querySelector('input[type=file]').files[0])
                    .then(documentB64 => {
                        this.document = documentB64;
                        this.$store.dispatch(SURVEY_ADD_TARGETS_REQUEST, {
                            "targets": this.document,
                            "id": this.survey_id
                        })
                            .then(() => {
                                this.$store.dispatch(GET_SURVEYS_REQUEST)
                                    .then(response => {
                                        this.surveysData = response.data.surveys
                                        this.$refs.formodal.close()
                                    })
                            })
                    })
            },
            downloadRawResults(survey_id) {
                this.$store.dispatch(GET_SURVEY_REQUEST, survey_id)
                    .then(response => {
                        let survey = response.data.survey;
                        let type = survey.rawresults.split(';')[0].split('/')[1];
                        let original_type = type;
                        if (type === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
                            type = "xlsx";
                        }
                        const linkSource = survey.rawresults;
                        const downloadLink = document.createElement("a");
                        const fileName = slugify(survey.label, '_') + "_" + survey.id + "." + type;
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(pdfBlobConvesion(linkSource, original_type), fileName);
                        }
                        else {
                            downloadLink.click();
                            document.body.appendChild(downloadLink);
                        }
                    })
                    .catch(error => {
                        console.log("ERROR is ====");
                        console.log(error)
                    })
            },
            downloadTargets(survey_id) {
                this.$store.dispatch(GET_SURVEY_REQUEST, survey_id)
                    .then(response => {
                        console.log("I GOT SURVEY")
                        let survey = response.data.survey;
                        let type = survey.targets.split(';')[0].split('/')[1];
                        let original_type = type;
                        if (type === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
                            type = "xlsx";
                        }
                        const linkSource = survey.targets;
                        const downloadLink = document.createElement("a");
                        const fileName = slugify(survey.label, '_') + "_" + survey.id + "." + type;
                        console.log(fileName);
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(pdfBlobConvesion(linkSource, original_type), fileName);
                        }
                        else {
                            downloadLink.click();
                            document.body.appendChild(downloadLink);
                        }
                    })
                    .catch(error => {
                        console.log("ERROR is ====");
                        console.log(error)
                    })
            },
            searchSurvey: function (e) {
                e.preventDefault();
                let date_begin = ''
                let date_end = '';
                if (this.date_begin !== '')
                    date_begin = moment(this.date_begin).format('YYYY-MM-DD');
                if (this.date_end !== '')
                    date_end = moment(this.date_end).format('YYYY-MM-DD');
                this.$store.dispatch(GET_SURVEYS_REQUEST, {
                    "date_begin": date_begin,
                    "date_end": date_end,
                    "type": this.type,
                    "state": this.state,
                    "partner_type": this.provider
                })
                    .then(response => {
                        this.surveysData = response.data.surveys
                    })
                
            },
            onexport (survey_id) { // On Click Excel download button
                var wb = XLSX.utils.book_new();
                this.$store.dispatch(GET_SURVEY_REQUEST, survey_id)
                .then(response => {
                    let survey = response.data.survey;
                    return Promise.all(survey.language.map(language => {
                        return Promise.all(survey.questions.map(question => {
                            return Promise.all(question.qtranslations.map(translation => {
                                if (translation.language.id === language.id || (language.slug !== 'en' && language.slug !== 'fr' && translation.language.slug == 'en' && question.source !== 'CORE')) {
                                    if (question.is_mandatory === true)
                                        question.is_mandatory = "TRUE";
                                    if (question.is_mandatory === false)
                                        question.is_mandatory = "FALSE";
                                    let questionReturn = {
                                        'label': translation.label,
                                        'is_mandatory': question.is_mandatory,
                                        'type': ''
                                    };
                                    if (question.type === 'TFREE'){
                                        if (translation.language.slug === 'fr'){
                                            questionReturn.type = "Réponse libre"
                                        } else {
                                            questionReturn.type = "Free answer"
                                        }

                                    } else if (question.type === 'TMULT'){
                                        if (translation.language.slug === 'fr'){
                                            questionReturn.type = "Choix multiple"
                                        } else {
                                            questionReturn.type = "Multiple choice"
                                        }
                                    } else if (question.type == 'TSING') {
                                        if (translation.language.slug === 'fr'){
                                            questionReturn.type = "Choix simple"
                                        } else {
                                            questionReturn.type = "Simple choice"
                                        }
                                    }
                                    for (let index = 0; index < translation.answers.length; index++) {
                                        questionReturn['answer_' + (index + 1)] = translation.answers[index].label;
                                    }
                                    return questionReturn;
                                }
                            }))
                                .then(translateReturns => {
                                    return translateReturns.filter(tr => tr !== undefined)[0]
                                })
                        }))
                            .then(questions => {
                                console.log("I THEN QUESTIONS");
                                console.log(questions);
                                XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(questions), language.name);
                            })
                            .catch(error => {
                                console.log("ERROR GENERATING FILE")
                                console.log(error);
                            })
                    }))
                        .then(() => {
                            XLSX.writeFile(wb, 'survey_'+ survey.publication_date+'_'+ slugify(survey.label, '_') + '.xlsx');
                        })
                })
            }
        }
    };
</script>
